import $ from 'jquery';

// Initialise les triggers "Lire plus"
// Replier / deplier les mentions legales
$('.js-lire-plus').click(function(e) {
  e.preventDefault();

  $(this)
    .toggleClass('lire-plus--deplie')
    .prev()
    .toggleClass('texte-legal-contenu--deplie', 400);
});
